<template lang="pug">
v-window(v-model="window")
  v-window-item
    p Вы хотите подписать {{ selected.length }} удостоверений
    .warning--text Это может занять некоторое время

    .d-flex
      v-btn.ml-auto(color="primary" text depressed @click="startSign") Продолжить
  v-window-item.px-2
    file-sign(
      ref="fileSign"
      :files="documents"
      hideLoaded
      :successCallback="signDocument"
      solo
      filled flat
      hideActions
      v-slot="{ targetFiles, signFiles, disabledSign }"
    )
      v-card.sdo-radius.overflow-auto.mb-2(flat).grey.lighten-4
        v-progress-linear.mb-2(
          stream
          :value="(signed.length  / (selected.length)) * 100"
          :buffer-value="(documents.length / (selected.length)) * 100"
          :color="documents.length === (selected.length) ? 'success' : 'amber'"
          height="24"
        )

        v-virtual-scroll.sdo-radius.overflow-auto.pt-0.px-2.scroll.grey.lighten-4(
          height="320"
          bench="20"
          :items="[...targetFiles, { loader: true }]"
          item-height="60"
          v-slot="{ item , index }"
        )
          v-list-item.white.mx-2.my-2(
            :key="index"
            v-if='!item.loader'
          ).px-4
            v-list-item-content.py-0
              .text-body-1
                v-icon.mr-2(color="secondary") mdi-certificate-outline
                span.
                  {{`${documents[index].diploma.serial} ${documents[index].diploma.number}`}}
            v-list-item-content.py-0
              div
                v-chip(
                  :color="item.signed ? 'success' : null"
                  small @click.stop="item.signed ? showSignature(item) : null"
                )
                  v-progress-circular.ml-1(
                    v-if="item.signing"
                    indeterminate
                    size="20"
                    width="2"
                  )
                  tooltip-wrap(text="Просмотр подписи")(v-else)
                    v-icon(
                      left size="20"
                    ) {{ item.signed ? 'mdi-key' : 'mdi-close-circle-outline' }}
                    span {{ item.signed ? 'Подписано' : 'Не подписано' }}
            v-list-item-action
              v-btn(icon small text color="primary" @click="getDocument(item.file.is)")
                v-icon(size="20") mdi-download
          v-skeleton-loader(
            v-else-if="loading"
            type="list-item-two-line"
          )
        div
          .text-center.warning--text.pt-1.text-body-2(
            v-if="!loading && documents.length !== selected.length"
          )
            v-icon(size="18" color="warning").mr-2.pb-1 mdi-alert-outline
            span Загрузка продолжиться после подписания
          .text-center.primary--text.pt-1.text-body-2(
            v-else-if="loading"
          )
            v-progress-circular.mb-1(size="18" color="primary" width="2" indeterminate).mr-2.pb-1
            span Загрузка документов
          .text-center.success--text.pt-1.text-body-2(
            v-else-if="signed.length !== selected.length"
          )
            v-icon(size="18" color="success").mr-2.pb-1 mdi-check
            span Все документы загружены
          .text-center.success--text.pt-1.text-body-2(
            v-else
          )
            v-icon(size="18" color="success").mr-2.pb-1 mdi-check
            span Все документы подписаны
          .d-flex.px-3.py-3.align-center
            div
              .text-body-2.pl-2.pt-1(
                :class="documents.length === selected.length ? 'success--text' : 'primary--text'"
              ).
                Загружено {{ documents.length }}/{{ selected.length }} документов
              .primary--text.text-body-2.pl-2.pt-1(
                :class=`{
                  'success--text': signed.length === selected.length,
                  'secondary--text': signed.length === 0,
                }`
              ).
                Подписано {{ signed.length }}/{{ selected.length }} документов
            v-btn.ml-auto.mr-2(
              :disabled="disabledSign || loading"
              :loading="loading"
              color="success"
              depressed large
              @click="() => { signFiles(); this.loading = true }"
            ) Подписать
              v-icon(right) mdi-key
</template>
<script>
import FileSign from '@/components/FileSignature/index.vue';
import ViewSignatures from '@/components/FileSignature/ViewSignatures.vue';

export default {

  components: {
    FileSign,
  },
  props: {
    selected: { type: Array, required: true },
    unSelected: { type: Array, default: () => [] },
    isUnselect: { type: Boolean, required: true },
    queryParams: { type: Object, default: () => {} },
  },
  data() {
    return {
      window: 0,
      signed: [],
      documents: [],
      hasNextPage: false,
      nextPage: 1,
      pagination: {},
      items: [],
      loading: true,
    };
  },
  methods: {
    getDocument(document) {
      const blob = new Blob([document], { type: 'application/pdf' });
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
    },
    async startSign() {
      this.window = 1;
      setTimeout(this.getPage(1), 400);
    },

    async getPage(page, sign = false) {
      this.loading = true;
      const response = await this.$api.diploma.getDiplomas({
        ...this.queryParams,
        'search[status]': 3,
        'per-page': 4,
        page,
      });
      this.hasNextPage = page < response.headers['x-pagination-page-count'];
      // if (this.hasNextPage)
      const items = response.data.data.filter(
        ({ id }) => (this.isUnselect
          ? !this.unSelected.includes(id)
          : this.selected.includes(id)) && !this.signed.includes(id),
      );
      if (this.hasNextPage && !items.length && this.documents.length !== this.selected.length) {
        this.nextPage = page + 1;
        await this.getPage(this.nextPage, sign);
        this.loading = false;
        return;
      }

      await items.reduce(async (previousPromise, item) => {
        await previousPromise;
        try {
          const res = await this.$api.diploma.orgDownloadDiploma(item.id);
          const newDocument = { is: res.data, diploma: item };
          this.documents.push(newDocument);
        } catch (error) {
          this.documents.push({ errorLoad: true, diploma: item });
        }
      }, Promise.resolve());
      // if (this.hasNextPage && page !== +response.headers
      // ['x-pagination-page-count'] && (page % 2 === 0)) await this.getPage(page + 1);
      if (sign) {
        this.$refs.fileSign.signFiles();
      }
      this.loading = false;
    },
    async signDocument(val) {
      this.loading = true;
      const promises = val.map((s) => s.validate());
      console.log(val);
      await Promise.all(promises);
      const payload = val.map((
        {
          hash,
          signature,
          signData: {
            commonName, lastName, street, subjectFederation, inn, linn, ogrn, ogrnip, snils, email,
            organization, country, locality, orgUnit, firstMiddleName,
            serialNumber, validFromDate, validToDate, issuerName, title,
          },
        },
        idx,
      ) => ({
        id: this.documents[idx].diploma.id,
        hash,
        position: title,
        sign_hash: signature,
        common_name: commonName,
        issuer_name: `${lastName} ${firstMiddleName}`,
        serial_number: serialNumber,
        valid_from_at: validFromDate,
        valid_to_at: validToDate,
        last_name: lastName,
        first_middle_name: firstMiddleName,
        title,
        org_unit: orgUnit,
        organization,
        locality,
        country,
        street,
        subject_federation: subjectFederation,
        inn,
        linn,
        ogrn,
        ogrnip,
        snils,
        email,
        sign_issuer_name: issuerName,
      })).filter(({ id }) => !this.signed.includes(id));
      await this.$api.diploma.signMassDiploma({ diplomas: payload }).then(() => {
        this.$toasted.success('Файлы успешно подписаны');
        this.loading = false;
        this.signed = val.map((_, idx) => this.documents[idx].diploma.id);
        if (this.hasNextPage && this.documents.length !== this.selected.length) {
          this.getPage(this.nextPage, true);
        } else this.$emit('sign');
      }).catch(() => { this.loading = false; });
      // this.signed = val.map((_, idx) => this.documents[idx].diploma.id);
      // console.log('doc', this.documents.length, this.selected.length);
      // if (this.hasNextPage && this.documents.length !== this.selected.length) {
      //   this.getPage(this.nextPage, true);
      // } else this.$emit('sign');
      // this.loading = false;
    },
    showSignature(signature) {
      this.$modals.show('generic-controller', {
        title: 'Просмотр подписей',
        dialogProps: {
          width: 700,
        },
        component: ViewSignatures,
        componentProps: {
          signatures: [signature],
        },
      });
    },
  },
};
</script>
